// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import EnvelopeFillerController from "./envelope_filler_controller"
application.register("envelope-filler", EnvelopeFillerController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PwaInstallTriggerController from "./pwa_install_trigger_controller"
application.register("pwa-install-trigger", PwaInstallTriggerController)

import RecurringSelectController from "./recurring_select_controller"

application.register("recurring-select", RecurringSelectController)

import RemovableController from "./removable_controller"
application.register("removable", RemovableController)

import SearchFilterController from "./search_filter_controller"
application.register("search-filter", SearchFilterController)

import SwipeContainerController from "./swipe_container_controller"
application.register("swipe-container", SwipeContainerController)

import TransitionController from "./transition_controller"
application.register("transition", TransitionController)

import TriggerEventController from "./trigger_event_controller"
application.register("trigger-event", TriggerEventController)

import UserTogglesController from "./user_toggles_controller"
application.register("user-toggles", UserTogglesController)
